// src/components/Layout.jsx
import React from "react";
import Header from "./Header";
import { Outlet, useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0); // scroll to top whenever route changes
  }, [pathname]);

  return null;
};

const Layout = () => {
  return (
    <div>
      <Header /> {/* always visible */}
      <ScrollToTop /> {/* ensures all pages start from top */}
      <main>
        <Outlet /> {/* renders the current page */}
      </main>
    </div>
  );
};

export default Layout;
